export * from './chip-list';
export * from './chip';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/chips/index.js
// module id = ../../../material/chips/index.js
// module chunks = 3